import { useConsentStore } from "../store/useConsentStore";
import { useState } from "react";

export default function CookieSettingsModal({ onClose }) {
  const { consent, setConsent, rejectAll, acceptAll } = useConsentStore();
  const [temp, setTemp] = useState({
    multimedia: consent?.multimedia || false,
    analytics: consent?.analytics || false,
  });

  return (
    <div className="fixed inset-0 bg-sidom-blue/50 flex justify-center items-center z-50">
      <div className="bg-gradient-to-t bg-sidom-dark text-sidom-light rounded-lg p-6 w-full max-w-xl shadow-lg">
        <h2 className="text-lg font-bold mb-4">Configuración de cookies</h2>

        <div className="space-y-2">
          <div className="flex justify-between">
            <span>Cookies funcionales</span>
            <span className="">Siempre activas</span>
          </div>

          <label className="flex justify-between items-center">
            <span>Cookies multimedia</span>
            <input
              type="checkbox"
              checked={temp.multimedia}
              onChange={(e) =>
                setTemp({ ...temp, multimedia: e.target.checked })
              }
            />
          </label>

          <label className="flex justify-between items-center">
            <span>Cookies analíticas</span>
            <input
              type="checkbox"
              checked={temp.analytics}
              onChange={(e) =>
                setTemp({ ...temp, analytics: e.target.checked })
              }
            />
          </label>
        </div>

        <div className="flex justify-end mt-6 space-x-3">
          <button
            onClick={() => {
              rejectAll();
              onClose();
            }}
            className="px-4 py-2 border rounded"
          >
            Rechazar todas
          </button>
          <button
            onClick={() => {
              acceptAll();
              onClose();
            }}
            className="px-4 py-2 bg-sidom-blue text-sidom-orange rounded"
          >
            Aceptar todas
          </button>
          <button
            onClick={() => {
              setConsent(temp);
              onClose();
            }}
            className="px-4 py-2 bg-sidom-light text-sidom-orange rounded"
          >
            Aceptar selección
          </button>
        </div>
      </div>
    </div>
  );
}
